<template>
  <div>
    <li class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2" v-if="srcOptions.length > 1">
      <span class="wf-w-1/2 wf-text-xs wf-tracking-wide wf-font-light wf-lowercase">source</span>
      <div class="wf-flex wf-w-1/2">
        <select class="wf-w-full" name="source_options" v-model="srcType">
          <option
            :key="srcOption.value"
            v-for="srcOption in srcOptions"
            :value="srcOption.value"
            v-text="srcOption.text"
          ></option>
        </select>
      </div>
    </li>
    <li v-show="srcType == 'media'" class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2 wf-justify-between wf-items-center">
      <span class="wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide">source image</span>
      <a
        href="#"
        @click.prevent="openImagesModal('sourceImage')"
        v-if="! src"
        class="wf-ml-auto wf-lowercase wf-text-blue-400 wf-underline wf-text-xs wf-cursor-pointer"
      ><i class="fas fa-image wf-mr-1"></i>select image</a>
      <div v-else class="wf-flex wf-items-center">
        <a
          href="#"
          class="wf-text-red-500 wf-text-xs wf-mr-1"
          @click.prevent="removeSrcImage"
        ><i class="fas fa-times mr-2"></i>remove</a>
        <div
          class="wf-cursor-pointer wf-block wf-h-8 wf-w-8 wf-border-2 wf-border-white wf-rounded-lg wf-shadow"
          style="background-position: center; background-size: cover;"
          :style="`background-image: url(${src})`"
          @click.prevent="openImagesModal('sourceImage')"
        ></div>
      </div>
    </li>
  </div>
</template>

<script>
  import MenuContentProperty from '../contracts/MenuContentProperty'
  export default MenuContentProperty.extend({
    computed: {
      srcOptions() {
        return [
          {value: 'media', text: 'Media Library'},
          {value: 'external', text: 'External Link'},
        ]
      },
      src() {
        if (this.srcType != 'media') {
          return
        }
        let sources = this.elementAssets[this.device].filter(asset => asset.element == 'sourceImage')
        if (! sources.length) {
          return
        }
        if (this.elementContent.srcSize == 'custom') {
          return sources.find(source => source.size == 'original').image
        }
        return sources.length ? sources.find(source => source.size == this.elementContent.srcSize).image : null
      },
      srcType: {
        get() {
          return this.elementContent.srcType
        },
        set(value) {
          this.addToObject(this.module, {srcType: value}, 'content')
          if (value == 'external') {
            this.addToObject(this.module, {srcSize: 'custom'}, 'content')
          }
        }
      },
    },
    methods: {
      removeSrcImage() {
        let sourceImages = this.elementAssets[this.device].filter(asset => asset.element == 'sourceImage')
        this.removeFromArray(this.module, sourceImages, 'assets')
      },
      openImagesModal(imageElement) {
        this.$modal.show('imagesModal', {
          ...this.element,
          currentImage: this.sourceImage,
          module: this.module,
          device: this.device,
          element: imageElement,
        })
      },
    },
  })
</script>